export interface TaskVariable {
  name: string;
  value?: string;
}

export enum MessageActionType {
  ACCEPT = 'accept',
  APPROVE = 'approve',
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not-available',
  REJECT = 'reject',
  SEEN = 'seen'
}

export type MessageAction = { [key in MessageActionType]?: MessageActionType };

export interface PlannerMessage {
  processInstanceId: string;
  executionId: string;
  taskDefinitionKey: string;
  createTime: string;
  taskVariables: TaskVariable[];
  active: boolean;
  taskName: string;
  message: {
    subject: string;
    body: string;
  };
  reply: string;
  actions: MessageAction[];
  taskId: string;
  requestId?: string;
}

export interface ParsedMessageData {
  employeeName: string;
  dateRange: string;
  taskTypeLabel: string;
  planUnit: string;
  createdAt: string;
  note: string;
  hoursDiff?: number | null;
  newHours?: number | null;
  leaveType?: string;
  planUnitChange?: string;
  dutyCodeChange?: string;
}

export interface TaskDefinition {
  name: string;
  count?: number;
}

export enum TaskStatusFilter {
  ALL = 'all',
  OPEN = 'open',
  HISTORY = 'history'
}

export enum PlannerTaskTab {
  ALL = 'ALL',
  LEAVE_REQUESTS = 'LEAVE_REQUESTS',
  DUTY_CHANGES = 'DUTY_CHANGES',
  FLEX_NOTIFICATIONS = 'FLEX_NOTIFICATIONS'
}

export interface PlannerMessagesFilters {
  tab: PlannerTaskTab;
  status: TaskStatusFilter;
  startDate: string | null;
  endDate: string | null;
  costCenterIds: string[];
}

export interface BatchActionResult {
  success: number;
  failed: number;
}
